export function openEventStream(path, onEvent) {
  let dead = false;
  let ctrl = new AbortController();
  const backoff = { ms: 700 };

  const run = async () => {
    while (!dead) {
      ctrl = new AbortController();
      try {
        const response = await fetch(path, {
          credentials: "include",
          headers: { Accept: "text/event-stream" },
          signal: ctrl.signal,
        });
        if (!response.ok || !response.body) throw new Error("stream");
        backoff.ms = 700;
        const reader = response.body.getReader();
        const decoder = new TextDecoder();
        let buf = "";
        while (!dead) {
          const { value, done } = await reader.read();
          if (done) break;
          buf += decoder.decode(value, { stream: true });
          const chunks = buf.split("\n\n");
          buf = chunks.pop() || "";
          chunks.forEach((chunk) => {
            const line = chunk.split("\n").find((row) => row.startsWith("data:"));
            if (!line) return;
            try {
              onEvent(JSON.parse(line.slice(5).trim()));
            } catch {
              /* ignore */
            }
          });
        }
      } catch {
        if (dead) return;
      }
      const wait = backoff.ms;
      await new Promise((resolve) => setTimeout(resolve, wait));
      backoff.ms = Math.min(Math.round(backoff.ms * 1.5), 8000);
    }
  };

  run();
  return () => {
    dead = true;
    ctrl.abort();
  };
}
